import { Image } from "./image";
import React from "react";
import {Helmet} from "react-helmet";

export const OtoSimetria = (props) => {
  return (
    <>
    <Helmet>
      <title>Correção das Orelhas de Abano | Dra Gabriela Antonio</title>
      <meta name="description" content="A OtoSimetria é uma técnica de correção das orelhas de abano com resultado imediato e duradouro, minimamente invasivo, sem cortes, sem cirurgia, utilizando fios de sustentação inseridos sob a pele e ancorados na cartilagem. É a equivalente mais moderna e segura da Otomodelação, Otoplastia Fechada, Otoplastia Cirúrgica, EarShut, Fragilize, Harmonização de Orelhas." />
    </Helmet>
    <div id="otosimetria" className="text-center">
      <div className="container">
        <div className="section-title">
          <p>CORREÇÃO DAS ORELHAS DE ABANO</p>
          <h2>OtoSimetria<sup>®</sup></h2>  
          <p>
            A OtoSimetria<sup>®</sup> é uma técnica de correção das orelhas de abano com resultado imediato e duradouro, minimamente invasivo, sem cortes, sem cirurgia, utilizando fios de sustentação inseridos sob a pele e ancorados na cartilagem. 
          </p>
          <h6 style={{ color: '#FFFFFF', fontSize: '2px' }}>É equivalente à Otomodelação, Otoplastia Fechada, Otoplastia Cirúrgica, EarShut, Fragilize, Harmonização de Orelhas</h6>
          <p>
            Veja meu portfólio de resultados no <a href="https://www.instagram.com/dra.gabriela.antonio?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noreferrer">Instagram  <i className="fa fa-instagram"></i></a>
          </p>  
        </div>     

        <div className="row">
          <div className="otosimetria-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      image={d.image}
                      description={d.description}
                    />
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>        

        <div className="otosimetria-btn">
          <a href="https://api.whatsapp.com/send?phone=5521980366885&text=Ol%C3%A1,%20vi%20a%20p%C3%A1gina%20web%20e%20%20gostaria%20de%20agendar%20uma%20consulta%20com%20a%20Dra.%20Gabriela%20Antonio." className="btn btn-custom btn-lg page-scroll" target="_blank" rel="noreferrer">
          Agendar Consulta <i className="fa fa-whatsapp"></i>
          </a>{" "}
        </div>        
        
      </div>
    </div>
    </>
  );
};
